import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DataTable, PageHeader, SectionCard } from '@striker/ui-shell';
import { apiFetch } from '../auth/session';

type PlanRow = {
  id: number;
  plan_code: string;
  name: string;
  price_monthly: number;
  stripe_price_id: string | null;
  has_stripe_price: boolean;
};

export function MasterPlansPage() {
  const [plans, setPlans] = useState<PlanRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const res = await apiFetch('/api/v1/master/plans');
        const body = (await res.json().catch(() => ({}))) as {
          plans?: PlanRow[];
          error?: string;
          message?: string;
        };
        if (!res.ok) throw new Error(body.message || body.error || `plans ${res.status}`);
        setPlans(Array.isArray(body.plans) ? body.plans : []);
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err));
      }
    })();
  }, []);

  return (
    <section className="sk-mc-page">
      <PageHeader
        title="Piani"
        subtitle={
          <>
            <Link to="/master">← Master</Link> · modello semplificato: piano Free + moduli a acquisto
          </>
        }
      />

      {error ? <p className="sk-error">{error}</p> : null}

      <SectionCard title="Modello attivo">
        <p style={{ marginBottom: '0.75rem' }}>
          Il sistema usa un modello <strong>Free + moduli</strong>: tutti i tenant si registrano
          con il piano Free (gratis) e acquistano i moduli singolarmente dallo store.
          I piani base/pro/elite sono stati rimossi.
        </p>
        <p>
          Per gestire i moduli disponibili (prezzi, Stripe price IDs), vai alla pagina{' '}
          <Link to="/master/modules">Moduli</Link>.
        </p>
      </SectionCard>

      <SectionCard title={`${plans.length} piani in catalogo`}>
        <DataTable
          emptyMessage="Nessun piano in catalogo"
          rows={plans}
          columns={[
            { key: 'id', label: 'ID' },
            { key: 'plan_code', label: 'Codice' },
            { key: 'name', label: 'Nome' },
            {
              key: 'price_monthly',
              label: '€ / mese',
              render: (v) => Number(v).toFixed(2),
            },
            {
              key: 'has_stripe_price',
              label: 'Stripe price',
              render: (v, row) => (v ? String(row.stripe_price_id) : '—'),
            },
          ]}
        />
      </SectionCard>
    </section>
  );
}
